import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-accent-500 rounded-lg">
                <i className="ri-links-line text-base text-background-50"></i>
              </div>
              <span className="text-base font-semibold text-foreground-950">
                JM网页版官网入口
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              JM网页版官网入口，提供最新官方网页版登录地址，一键直达JM官网入口，无需下载APP即可访问，安全稳定的JM网页版通道。
            </p>
            <div className="flex items-center gap-3">
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer"
                aria-label="微信"
              >
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer"
                aria-label="微博"
              >
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer"
                aria-label="邮箱"
              >
                <i className="ri-mail-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              分类导航
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  网站首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#jm-entry"
                  className="text-sm text-foreground-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  JM官方入口
                </a>
              </li>
              <li>
                <Link
                  to="/category/tutorial"
                  className="text-sm text-foreground-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  使用教程
                </Link>
              </li>
              <li>
                <Link
                  to="/category/faq"
                  className="text-sm text-foreground-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  常见问题
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-foreground-500 mt-0.5"></i>
                <span className="text-sm text-foreground-600">
                  support@jm-official.com
                </span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-foreground-500 mt-0.5"></i>
                <span className="text-sm text-foreground-600">
                  400-XXX-XXXX
                </span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line text-foreground-500 mt-0.5"></i>
                <span className="text-sm text-foreground-600">
                  周一至周日 9:00 - 21:00
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} JM网页版官网入口. 本站为非官方导航站点，仅供信息参考。
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              使用条款
            </a>
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}